<template>
    <div
        class="flex gap-4"
        :class="{
            'flex-wrap items-center': block.ButtonStack === 'horizontal',
            'max-sm:flex-col': block.ButtonWidth == 'fill-width',
            'flex-col flex-nowrap justify-center': block.ButtonStack === 'vertical',
            'justify-center':
                block.Alignment === 'centred' &&
                block.ButtonStack === 'horizontal' &&
                block.ButtonWidth !== 'fill-width',
            'items-center':
                block.Alignment === 'centred' && block.ButtonStack === 'vertical' && block.ButtonWidth !== 'fill-width',
            'justify-end':
                block.Alignment === 'right' && block.ButtonStack === 'horizontal' && block.ButtonWidth !== 'fill-width',
            'items-end':
                block.Alignment === 'right' && block.ButtonStack === 'vertical' && block.ButtonWidth !== 'fill-width',
        }"
    >
        <NuxtLink
            v-for="(button, index) in block.Buttons"
            :key="index"
            :to="button.url"
            :target="button.target"
            :class="{
                'flex-1 max-sm:w-full': block.ButtonWidth === 'fill-width',
            }"
        >
            <DButton
                :left-icon="button?.iconPosition === 'left' ? iconName(button?.icon) : null"
                :theme="buttonTheme(button.buttonStyle)"
                size="lg"
                link-size="lg"
                :right-icon="button?.iconPosition === 'right' ? iconName(button?.icon) : null"
                :class="{
                    'justify-center': block.Alignment === 'centred' && block.ButtonWidth === 'fill-width',
                    'justify-end': block.Alignment === 'right' && block.ButtonWidth === 'fill-width',
                    'w-full': block.ButtonWidth === 'fill-width',
                }"
            >
                <div class="flex w-full flex-1 justify-between">
                    {{ button.text }}
                </div>
            </DButton>
        </NuxtLink>
    </div>
</template>

<script setup>
    import { DButton } from '@digistorm/spark'

    const { iconName } = useIcons()

    const { buttonTheme } = useButtonTheme()

    defineProps({
        block: Object,
    })
</script>
